import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Loading from '@/components/widgets/Loading.vue'
import Paginate from "@/components/widgets/pagination.vue";
import Popup from "../item-list-for-deliver-popup";
import Popup2 from "../delivery-documents-popup";
import moment from 'moment'
const _ = require('lodash')

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})
export default {
  components: {
    DatePicker,
    Loading,
    Paginate,
    Popup,
    Popup2
  },
  data: function () {
    return {
      products: [],
      isShowingSelectProductForDelivery: false,
      isShowingDeliveryDocumentList: false,
      selectUUID: "",
      selectBillNo: "",
      selectBillGrandTotal: 0,
      selectIsDynamic: false,
      role: "",
      branch: "",
      loading: false,
      busy: false,
      apiStatus: 'ไม่พบข้อมูล',
      totalItem: 0,
      keyword_status: null,
      keyword_dynamic: null,
      dynamicFilterOptions: [
        { value: 'dynamic_all', text: 'งานล่ำซำ - ทั้งหมด' },
        { value: 'dynamic_active', text: 'งานล่ำซำ - กำลังดำเนินการ' },
        { value: 'dynamic_invoicing', text: 'งานล่ำซำ - กำลังวางบิล' },
        { value: 'dynamic_ended', text: 'งานล่ำซำ - จบโครงการแล้ว' },
        { value: 'free_all', text: 'ส่งอิสระ - ทั้งหมด' },
        { value: 'free_active', text: 'ส่งอิสระ - กำลังดำเนินการ' },
        { value: 'free_ended', text: 'ส่งอิสระ - จบโครงการแล้ว' },
        { value: 'non_dynamic', text: 'บิลปกติ (ไม่ใช่ล่ำซำ/ส่งอิสระ)' }
      ],
      doc: {
        start: null,
        end: null
      },
      duedate: {
        start: null,
        end: null
      },
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      keyword: '',
      fields: [
        {
          key: 'bill_no',
          label: 'เลขใบรับคำสั่งซื้อ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'ลงวันที่',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'bill_shipping_date',
          label: 'จัดส่ง',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'customer',
          label: 'ชื่อลูกค้า/โครงการ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'sale_total',
          label: 'ยอดคำสั่งซื้อสุทธิ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          class: 'text-right',
          sortable: true
        },
        {
          key: 'bill_seller',
          label: 'ผู้ขาย',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'bill_note',
          label: 'หมายเหตุ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          class: 'text-left',
          sortable: true
        },
        {
          key: 'status',
          label: 'สถานะการทำบิล',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'action',
          label: '#',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          class: 'text-right'
        }
      ],
      items: []
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    // tooltip บอกว่าอยู่ในใบวางบิลไหน (backend แนบ billing_note_nos มาให้เฉพาะบิลล่ำซำ)
    billingNoteNos(item) {
      const nos = item?.billing_note_nos || []
      return nos.length ? 'ใบวางบิล: ' + nos.join(', ') : 'กำลังวางบิล'
    },
    // ประเภท VAT ของบิลไม่ตรงกับใบเสนอราคาหรือไม่ (ข้ามถ้าไม่ได้อ้างอิงใบเสนอ)
    isVatMismatch(item) {
      const q = item?.quotation_document
      if (!q || q.vatable == null) return false
      return parseInt(item.bill_tax_type) !== parseInt(q.vatable)
    },
    getProjectName(item) {
      if (!item) return ''
      // item คือ bill → trace: bill.quotation_document.project_name
      return item?.quotation_document?.project_name || ''
    },
    rowClass(item) {
      if (item && item.is_dynamic && item.is_complete_deliver) return 'dynamic-row dynamic-ended-row'
      if (item && item.is_dynamic) return 'dynamic-row'
      // ส่งอิสระ (ไม่ใช่ล่ำซำ): highlight ฟ้า; จบโครงการแล้วให้เขียวเหมือนล่ำซำที่จบ
      if (item && item.is_free_delivery && item.is_complete_deliver) return 'dynamic-ended-row'
      if (item && item.is_free_delivery) return 'free-delivery-row'
      return ''
    },
    async getRole() {
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res.data.role
      this.branch = res.data.branch_id
    },
    onEndDynamicProject(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-danger"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">ยืนยันจบโครงการ?</span>' +
          '<span class="text-base text-left text-gray-500">หากยืนยันแล้ว จะไม่สามารถสร้างใบส่งของจากบิลงานล่ำซำนี้ได้อีก และไม่สามารถย้อนกลับได้</span>' +
          '</div>' +
          '</div>',
        input: 'textarea',
        inputPlaceholder: 'ระบุเหตุผลการยกเลิก (อย่างน้อย 3 ตัวอักษร)',
        inputAttributes: { 'aria-label': 'เหตุผลการยกเลิก', maxlength: 1000 },
        inputValidator: (value) => {
          const v = (value || '').trim()
          if (v.length < 3) return 'กรุณาระบุเหตุผลการยกเลิกอย่างน้อย 3 ตัวอักษร'
          if (v.length > 1000) return 'เหตุผลการยกเลิกต้องไม่เกิน 1000 ตัวอักษร'
          return null
        },
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "จบโครงการ",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmEndDynamicProject(id)
        }
      })
    },
    async onConfirmEndDynamicProject(id) {
      try {
        this.loading = true
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/completeDynamicBill/${id}`
        );
        setTimeout(() => {
          this.loading = false
          if (result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">จบโครงการเรียบร้อยแล้ว</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(() => {
              this.onInitData(this.currentPage)
            })
          }
        }, 500)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler(error?.response?.data?.message ?? 'เกิดข้อผิดพลาด');
      }
    },
    onReopenDynamicProject(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">เปิดโครงการอีกครั้ง?</span>' +
          '<span class="text-base text-left text-gray-500">หากยืนยันแล้ว จะสามารถสร้างใบส่งของจากบิลงานล่ำซำนี้ได้ต่อ</span>' +
          '</div>' +
          '</div>',
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "เปิดโครงการ",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmReopenDynamicProject(id)
        }
      })
    },
    async onConfirmReopenDynamicProject(id) {
      try {
        this.loading = true
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/reopenDynamicBill/${id}`
        );
        setTimeout(() => {
          this.loading = false
          if (result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">เปิดโครงการอีกครั้งเรียบร้อย</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(() => {
              this.onInitData(this.currentPage)
            })
          }
        }, 500)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler(error?.response?.data?.message ?? 'เกิดข้อผิดพลาด');
      }
    },
    onallowedit(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการเปิดการแก้ไขใบรับคำสั่งซื้อนี้หรือไม่?</span>' +
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว จะเป็นการเปิดการแก้ไขใบรับคำสั่งซื้อได้ 1 ครั้ง?</span>' +
          '</div>' +
          '</div>',
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonColor: '#dc4a38',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "ตกลง",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmEdit(id)
        }
      })
    },
    ondeleted(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการจะยกเลิกใบรับคำสั่่งซื้อนี้หรือไม่?</span>' +
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว ใบเสนอราคา ใบส่งสินค้าทุกใบที่เกี่ยวข้องกับใบรับคำสั่งซื้อนี้ และลีด(ถ้ามี) จะถูกยกเลิกไปด้วยและไม่สามารถย้อนกลับได้?</span>' +
          '</div>' +
          '</div>',
        input: 'textarea',
        inputPlaceholder: 'ระบุเหตุผลการยกเลิก (อย่างน้อย 3 ตัวอักษร)',
        inputAttributes: { 'aria-label': 'เหตุผลการยกเลิก', maxlength: 1000 },
        inputValidator: (value) => {
          const v = (value || '').trim()
          if (v.length < 3) return 'กรุณาระบุเหตุผลการยกเลิกอย่างน้อย 3 ตัวอักษร'
          if (v.length > 1000) return 'เหตุผลการยกเลิกต้องไม่เกิน 1000 ตัวอักษร'
          return null
        },
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          popup: 'swal2-custom-rounded',
          closeButton: 'text-3xl swal2-custom-close',
          actions: 'justify-content-end',
          contant: 'd-flex flex-row justify-content-around px-2',
          title: 'd-none',
          confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
        },
        cancelButtonColor: '#dc4a38',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: "ตกลง",
        showCancelButton: true,
        showCloseButton: true,
      }).then(async confirm => {
        if (confirm.value) {
          this.loading = true
          this.onConfirmDelete(id, (confirm.value || '').trim())
        }
      })
    },
    async onConfirmDelete(id, cancel_reason) {
      try {
        const param = { id: id, cancel_reason: cancel_reason }
        this.loading = true
        const result = await this.$store.dispatch('Bills/delete', param, { root: true })
        setTimeout(() => {
          this.loading = false
          if (result.status === 204) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">ยกเลิกเอกสารเรียบร้อยแล้ว</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              cancelButtonColor: '#dc4a38',
              cancelButtonText: 'ยกเลิก',
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(async confirm => {
              if (confirm.value) {
                this.onInitData(this.currentPage)
              }
            })
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onConfirmEdit(id) {
      try {
        const param = {
          id: id
        }
        this.loading = true
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/enableBillEditing/${id}`
        );
        setTimeout(() => {
          this.loading = false
          if (result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
                '<div class="d-flex flex-column">' +
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
                '<span class="text-base text-left text-gray-500">เปิดให้แก้ไขเอกสารแล้ว</span>' +
                '</div>' +
                '</div>',
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                popup: 'swal2-custom-rounded',
                closeButton: 'text-3xl swal2-custom-close',
                actions: 'justify-content-end',
                contant: 'd-flex flex-row justify-content-around px-2',
                title: 'd-none',
                confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
              },
              cancelButtonColor: '#dc4a38',
              cancelButtonText: 'ยกเลิก',
              confirmButtonText: "ตกลง",
              showCancelButton: false,
              showCloseButton: true,
            }).then(async confirm => {
              if (confirm.value) {
                this.onInitData(this.currentPage)
              }
            })
          }
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    oncreate() {
      this.$router.push("/billing/create")
    },
    onInfo(id) {
      this.$emit('componentInfo', {
        status: true,
        component: 'billing-info'
      })
    },
    onedit(uuid) {
      const routeData = this.$router.resolve("/billing/create/" + uuid);
      window.open(routeData.href, "_blank");
    },
    async onInitData(currentPage) {
      this.currentPage = currentPage
      try {
        // this.items = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const page = currentPage ? currentPage : 1
        const query = new URLSearchParams({
          page: String(page),
          perPage: "8",
          keyword: this.keyword != null ? String(this.keyword) : "",
          keyword_status: this.keyword_status != null ? String(this.keyword_status) : "",
          keyword_dynamic: this.keyword_dynamic != null ? String(this.keyword_dynamic) : "",
          keyword_startdate: this.doc.start ? moment(this.doc.start).format('YYYY-MM-DD') : "",
          keyword_enddate: this.doc.end ? moment(this.doc.end).format('YYYY-MM-DD') : "",
          keyword_start_shipdate: this.duedate.start ? moment(this.duedate.start).format('YYYY-MM-DD') : "",
          keyword_end_shipdate: this.duedate.end ? moment(this.duedate.end).format('YYYY-MM-DD') : ""
        })
        const url = `${Vue.prototype.$host}/api/v1/bills?${query.toString()}`
        const param = {
          keyword: this.keyword,
          url: url
        }
        const result = await this.$store.dispatch('Bills/getAll', param, { root: true })
        setTimeout(() => {
          this.busy = false
          this.apiStatus = 'ไม่พบข้อมูล'

          if (result) {
            this.currentData = result.data;
            this.items = result.data.data
            this.totalItem = result.data.total
          } else {
            this.items = []
            this.totalItem = 0
          }
        }, 500)
      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onPrintProductionHandler() {
      this.$emit('componentInfo', {
        status: true,
        component: 'production'
      })
    },
    generateQRcode(uuid) {
      try {
        this.loading = true
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/downloadBillPDF/" + uuid,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              responseType: "blob"
            }
          )
          const blob = new Blob([result.data], { type: 'application/pdf' });
          const objectUrl = URL.createObjectURL(blob)
          window.open(objectUrl, 'targetWindow',
            `toolbar=no,
          location=no,
          status=no,
          menubar=no,
          scrollbars=yes,
          resizable=yes,
          width=SomeSize,
          height=SomeSize`);

          // const link = document.createElement("a");
          // link.href = objectUrl;
          // this.pdfsrc = objectUrl
          // link.setAttribute(
          //   "download",
          //   `ใบเสนอราคา-${name}.pdf`
          // );
          // document.body.appendChild(link);
          // link.click();

          // URL.revokeObjectURL(objectUrl)
          this.loading = false
        }, 1000)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onCreateDeliveryDocument(e) {
      this.selectUUID = ""
      this.isShowingSelectProductForDelivery = false

      if (e.status) {
        const productsWithoutHeader = (e.data || []).filter(key => key.type === 1)
        // งานล่ำซำ: ผ่านได้แม้ไม่ได้เลือกสินค้า (สร้างใบเปล่าได้)
        if (!e.is_dynamic && productsWithoutHeader.length === 0) {
          this.$swal({
            title: 'แจ้งเตือน',
            type: 'error',
            html:
              'กรูณาเลือกสินค้าอย่างน้อย 1 ชิ้น เพื่อสร้างใบส่งสินค้า',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText:
              'ตกลง',
            confirmButtonAriaLabel: 'OK',
          })
        }
        else {
          this.createDeliveryDocument(e)
        }
      }
    },
    onOpenPopup(uuid, isDynamic = false) {
      this.selectUUID = uuid
      this.selectIsDynamic = !!isDynamic
      this.isShowingSelectProductForDelivery = true
    },
    onCreateDynamicDelivery(billUuid) {
      // งานล่ำซำ: เปิดหน้าสร้างใบส่งของใหม่ พร้อม prefill จากบิล
      const routeData = this.$router.resolve({
        path: '/billing/create/' + billUuid,
        query: { delivery: 'true', dynamic: 'true' }
      })
      window.open(routeData.href, '_blank')
    },
    onOpenPopup2(uuid, billNo, billGrandTotal, isDynamic) {
      this.selectUUID = uuid
      this.selectBillNo = billNo ?? ""
      this.selectBillGrandTotal = parseFloat(billGrandTotal ?? 0) || 0
      this.selectIsDynamic = !!isDynamic
      this.isShowingDeliveryDocumentList = true
    },
    onConvertToProduction(uuid) {
      this.$router.push({ path: 'production/create', query: { q: uuid } })
    },
    async createDeliveryDocument(e) {
      const items = e.data
      for (let index = 0; index < items.length; index++) {
        const element = items[index]
        this.products.push(element)
      }

      const formData = new FormData()
      formData.append('products', JSON.stringify(this.products))
      formData.append('show_price', e.show_price)
      formData.append('remark', e.remark)

      formData.append('subtotal', e.subtotal)
      formData.append('discount', e.discount)
      formData.append('before_vat', e.before_vat)
      formData.append('vatable', e.vatable)
      formData.append('vat', e.vat)
      formData.append('deposit', e.deposit)
      formData.append('total_price', e.total)
      formData.append('is_complete_delivery', e.is_complete_delivery)
      formData.append('is_dynamic', e.is_dynamic ? 1 : 0)
      formData.append('deposit_document_id', e.deposit_document_id)
      formData.append('deposit_document_no', e.deposit_document_no)


      try {
        this.loading = true;
        const result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/document/delivery/${e.uuid}`
          , formData)

        this.loading = false;
        if (result.status === 201) {
          this.$swal({
            title: 'สร้างใบส่งสินค้าสำเร็จ',
            type: 'success',
            html:
              'ระบบจะพาท่านไปยังเมนูใบส่งสินค้า' + this.stockWarningsHtml(result.data?.stock_warnings),
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText:
              'ตกลง',
            confirmButtonAriaLabel: 'OK',
          }).then(() => {
            this.$router.push('/delivery')
          })
        }
      } catch (error) {
        this.loading = false;
        let message = error.response
          ? error.response.data.message
          : error.message;
        this.onExceptionHandler(message);
      }
    }
  },
  mounted() {
    this.getRole()
    this.onInitData(this.currentPage)
  }
}
